export const REACT_APP_API_URL = "https://nbapiv2.onameter.com"
export const METER_TEMPLATE = "/files/水表安装资料导入模板.xlsx"
export const METER_TEMPLATE_FILENAME = "水表安装资料导入模板.xlsx"
export const FOOTER_TEXT = "2021 Smarthome Products (Shenzhen) Co., Ltd. All rights reserved"
export const PAGESIZE = 10
